<ng-container *ngIf="projects.length > 0 && !!projects">
  <h3>Verwendet in folgenden Projekten:</h3>

  <clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column>Projektnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'company_name'">Kunde</clr-dg-column>
    <clr-dg-column [clrDgField]="'name_project'">Projektname</clr-dg-column>
    <clr-dg-column [clrDgField]="'status'">Status</clr-dg-column>
    <clr-dg-column [clrDgField]="'start_project'">Start</clr-dg-column>
    <clr-dg-column [clrDgField]="'end_project'" [clrDgSortOrder]="descSort">Ende</clr-dg-column>
    <clr-dg-placeholder>Kein dazugehöriges Projekt gefunden!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let project of projects" [routerLink]="['/project/details', project.cid, project.id_project]">
      <clr-dg-cell>{{ project.cid }}.{{ project.id_project }}</clr-dg-cell>
      <clr-dg-cell>{{ project.company_name }}</clr-dg-cell>
      <clr-dg-cell>{{ project.name_project }}</clr-dg-cell>
      <clr-dg-cell>{{ project.status }}</clr-dg-cell>
      <clr-dg-cell>{{ formatProjectDate(project.start_project) }}</clr-dg-cell>
      <clr-dg-cell>{{ formatProjectDate(project.end_project) }}</clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Projekte pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von {{projects.length}} Projekt(en)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</ng-container>
